'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-09-14
 */
// import {Person} from 'janux-people'
import _ from 'lodash'
import {Person, EmailAddress, PhoneNumber, PostalAddress} from 'janux-people'

export function userActionService (http, partyService) {
	return {
		// Load invitation by code
		findByCode: (code) => {
			return http.jsonrpc(
				'/rpc/public/userAction',
				'findOneByCode',
				[ code ]
			).then((resp) => {
				let out = resp.result
				const id = out.account.contact.id
				out.account.contact = partyService.fromJSON(out.account.contact)
				out.account.contact.id = id
				return out
			})
		},

		// Load invitation by account id
		findByAccountId: (accountId) => {
			return http.jsonrpc(
				'/rpc/2.0/userAction',
				'findOneByAccountId',
				[ accountId ]
			).then((resp) => {
				const out = resp.result
				return out
			})
		},

		findByAccountIdsIn: (accountIds) => {
			return http.jsonrpc(
				'/rpc/2.0/userAction',
				'findByAccountIdsIn',
				[ accountIds ]
			).then((resp) => {
				const out = resp.result
				return out
			})
		},

		// Add new user
		insert: function (userObj) {
			let user = {
				username: userObj.account.username,
				password: userObj.account.password,
				enabled: true,
				locked: false,
				expire: undefined,
				expirePassword: undefined,
				contact: {},
				roles: ['DESIGNER']
			}

			let person = new Person('', userObj.contact.firstName, '', userObj.contact.lastName, '')
			const email = new EmailAddress(userObj.contact.email)
			person.setContactMethod('work', email)
			person.setContactMethod('WORK', new PhoneNumber())
			person.setContactMethod('WORK', new PostalAddress())

			user.contact = person.toJSON()
			user.contact.typeName = 'PersonImpl'

			return http.jsonrpc(
				'/rpc/public/userAction',
				'insert',
				[ user ]
			).then((resp) => {
				const out = resp.result
				return out
			}).catch((err) => {
				throw err.body.error[0]
			})
		},

		update: (invitation) => {
			let userInvObjClone = _.cloneDeep(invitation)
			const id = userInvObjClone.account.contact.id
			const typeName = userInvObjClone.account.contact.typeName
			userInvObjClone.account.contact = partyService.toJSON(userInvObjClone.account.contact)
			userInvObjClone.account.contact.id = id
			userInvObjClone.account.contact.typeName = typeName

			return http.jsonrpc(
				'/rpc/public/userAction',
				'update',
				[ userInvObjClone ]
			).then((resp) => {
				const out = resp.result
				console.log('updated invitation', out)
				return out
			})
		},

		/**
		 *
		 * @param contactId
		 * @param selectedEmail
		 * @param assignedRoles
		 */
		inviteToCreateAccount: (contactId, selectedEmail, assignedRoles) => {
			return http.jsonrpc(
				'/rpc/2.0/userAction',
				'inviteToCreateAccount',
				[contactId, selectedEmail, assignedRoles]
			).then((resp) => {
				return resp.result
			})
		},

		/**
		 *
		 * @param accountId
		 * @param selectedEmail
		 */
		recoverPassword: (accountId, contactId, selectedEmail) => {
			return http.jsonrpc(
				'/rpc/public/userAction',
				'recoverPassword',
				[ accountId, contactId, selectedEmail ]
			).then((resp) => {
				const out = resp.result
				return out
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/services/user-action-service.js